var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSepticTank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.37;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-2{stroke:#dbb391;stroke-width:.19px;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-6{fill:url(#linear-gradient);}.cls-3{stroke:#efefef;stroke-width:.2px;}.cls-4{stroke:#c4d6b8;stroke-width:.1px;}.cls-7{fill:#f3efe7;}.cls-8{fill:#fa5396;}.cls-9{fill:#f2efea;}.cls-10{fill:#f9e5c5;}.cls-11{fill:#027180;}.cls-12{fill:#014750;}.cls-13{fill:#6a7265;}.cls-14{fill:#e9cda7;}.cls-15{fill:#fff;}.cls-16{fill:#fcc209;}.cls-17{fill:#fbfff9;}.cls-18{fill:#e5e5e5;}.cls-19{fill:#e6d0ad;}.cls-20{fill:#fbd898;}.cls-21{fill:#fbcd7a;}.cls-22{fill:#928d78;}.cls-23{fill:#93959d;}.cls-24{fill:#93a59a;}.cls-25{fill:#b4b6bf;}.cls-26{fill:#8c6ffb;}.cls-27{fill:#8d643e;}.cls-28{fill:#8d7557;}.cls-29{fill:#bac8cf;}.cls-30{fill:#bdc7c6;}.cls-31{fill:#bcc4c7;}.cls-32{fill:#c3af8d;}.cls-33{fill:#dbb391;}.cls-34{fill:#c9a587;}.cls-35{fill:#dcdcdc;}.cls-36{fill:#dbdbdb;}.cls-37{fill:#d9e5c8;}.cls-38{fill:#ac856c;}.cls-39{fill:#dfdedd;}.cls-40{fill:#41939e;}.cls-41{fill:#358628;}.cls-42{fill:#6e513d;}.cls-43{fill:#88c0c4;}.cls-44{fill:#85ba58;}.cls-45{fill:#576255;}.cls-46{fill:#839379;}.cls-47{fill:#74b599;}.cls-48{fill:#79b399;}.cls-5{stroke:#93a59a;stroke-width:.18px;}.cls-49{isolation:isolate;opacity:.1;}.cls-50{fill:#191919;opacity:.2;}.cls-51{fill:url(#linear-gradient-2);}.cls-52{fill:#6ab9d0;}.cls-52,.cls-53{opacity:.6;}.cls-53,.cls-54,.cls-55{fill:#a0c6a8;}.cls-54,.cls-56{opacity:.5;}.cls-56{fill:#8bbfd9;}.cls-55{opacity:.3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.61,
    y1: 296.2,
    x2: 55.62,
    y2: 288.81,
    gradientTransform: "translate(0 319.42) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93cb38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79993a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 52.58,
    y1: 301.47,
    x2: 65.7,
    y2: 296.08,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Septic_tank"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24.02,35.3s.06.03.08.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "72.83 36.98 72.83 36.98 44.46 53.29 18.95 37.89 46.92 21.87 72.83 36.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m50.3,43.51s-.1,0-.15-.01c-.05-.02-.09-.04-.13-.08-.18-.09-.18-.18-.18-.36s0-.27.09-.27h.73s.11.08.18.09c.05.05.08.11.09.18l-.09.18c0,.06-.03.08-.08.11-.04.02-.07.05-.1.07-.09.09-.18.09-.36.09Zm6.01-.09h-.36c-.18,0-.27,0-.36-.09,0-.07-.04-.13-.09-.18h0c.26-.21.57-.34.91-.36h.02c.07.01.07.11.07.27,0,.18,0,.27-.09.27-.02,0-.05,0-.06.03s-.03.04-.03.06h0Zm-2.1,0c-.18,0-.27,0-.27-.09,0-.07-.04-.13-.09-.18.09-.14.21-.26.35-.34.14-.08.31-.12.47-.12.06.08.09.17.09.27-.05.05-.09.12-.11.19-.02.06-.05.12-.07.17-.09.09-.18.09-.36.09Zm-5.65,0h-.36c-.19,0-.29,0-.31-.03,0-.01,0-.03.03-.06l-.09-.27.09-.27h.73c.09,0,.09.09.09.27s0,.27-.09.27l-.09.09Zm3.64-1.09c-.29,0-.46-.1-.46-.27.1-.29.29-.46,1-.46.09,0,.09.09.09.27s0,.27-.09.27l-.09.09-.46.09Zm-1.55-.27h-.18c-.18-.09-.27-.18-.27-.27.02-.06.05-.12.1-.17.05-.05.11-.08.17-.1.07,0,.13.04.18.09.02-.02.04-.04.06-.04s.03.02.03.06c0,.05,0,.11,0,.16,0,.18,0,.27-.09.27Zm3.46-.18c-.29,0-.46-.1-.46-.27h.01c.22-.11.42-.23.62-.36.1,0,.19-.01.28-.05.06-.03.12-.04.18-.04.09,0,.09.09.09.27s0,.27-.09.27c-.02,0-.05,0-.06.03-.02.02-.03.04-.03.06l-.55.09Zm-3.55-.91s-.1,0-.15-.01c-.05-.02-.09-.04-.13-.08l-.18-.18c.02-.06.05-.12.1-.17.05-.05.11-.08.17-.1.03-.02.06-.02.1-.02.13,0,.27.12.45.39-.04.06-.1.1-.16.13-.06.03-.13.05-.2.05Zm2.1-.27c-.07,0-.14-.03-.19-.08-.05-.05-.08-.12-.08-.19,0-.18.18-.27.36-.36.11-.06.24-.1.36-.09h.09c.09,0,.09.09.09.27,0,.08-.13.15-.44.34l-.2.12Zm1.37-.46h-.36c-.18,0-.27,0-.36-.09v-.18c.07-.15.19-.28.34-.36.15-.08.32-.11.48-.09.09,0,.18.09.18.27,0,.05,0,.1-.01.15-.02.05-.04.09-.08.13l-.09.09-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m48.3,45.88h-.18c-.09,0-.17-.02-.25-.06-.04-.02-.08-.03-.12-.03v-.46l.09-.09h.55l.08.04c.1.03.2.09.28.16.08.07.14.16.19.26-.18.14-.41.21-.64.18Zm5.38-.55h-.64c-.1-.07-.19-.12-.27-.17-.1-.05-.19-.12-.27-.19v-.09c0-.18,0-.27.09-.27l.09.09c.05-.11.08-.15.12-.15.05.01.11.03.15.06.09,0,.18,0,.18.09.25.1.47.25.64.46q-.09.09-.09.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m53.13,45.7c-.3-.07-.57-.19-.82-.36-.08-.07-.14-.15-.19-.25-.05-.09-.07-.2-.08-.3,0-.51.29-.75.91-.75.12,0,.24,0,.36.02.83.09,1.28.38,1.28.82,0,.17-.07.33-.18.46-.14.11-.29.2-.46.27-.27.08-.54.11-.82.09Zm-.64-1.18c-.06.08-.1.17-.09.27v.09c.08.07.18.14.27.19.08.05.17.1.27.17h.64q0-.09.09-.18c-.2-.21-.45-.37-.73-.46-.06,0-.12,0-.17-.02-.03-.01-.07-.02-.1-.02-.02,0-.03,0-.05.01-.02,0-.03.02-.04.03l-.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m48.39,47.16c-.15-.01-.29-.06-.42-.14-.13-.08-.23-.19-.31-.32-.04-.04-.07-.09-.09-.14-.02-.05-.05-.1-.09-.14.26.09.54.12.82.09.12.02.25.04.37.04.22,0,.43-.04.63-.13,0,.07-.04.13-.09.18-.07.16-.18.3-.33.4-.15.1-.32.15-.49.15Zm4.83-.82c-.13,0-.26-.03-.37-.09s-.21-.16-.27-.27c-.15-.16-.28-.34-.36-.55.18.18.45.18.82.18.31.03.62,0,.91-.09v.36c-.06.14-.16.27-.29.35-.13.08-.29.12-.44.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m48.39,46.61c-.28.03-.56,0-.82-.09-.17-.06-.32-.17-.44-.32-.11-.14-.18-.32-.2-.5,0-.29.21-.56.64-.82.41-.04.71-.05.95-.05.34-.05.68.04.96.24.18.09.18.27.18.64l-.09.46c0,.09,0,.27-.27.27-.29.12-.6.18-.91.18Zm-.55-.82c.09.09.18.09.36.09h.27c.23,0,.45-.05.64-.18h0c-.16-.18-.34-.33-.54-.46h-.55l-.09.09c-.08,0-.13.02-.16.06-.02.04-.03.08-.02.12,0,.21,0,.31.04.31.01,0,.03-.01.05-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m44.02,37.18s-.1,0-.15-.01c-.05-.02-.09-.04-.13-.08-.18-.09-.18-.18-.18-.36s0-.27.09-.27h.73s.11.08.18.09c.05.05.08.11.09.18l-.09.18c0,.06-.03.08-.08.11-.04.02-.07.05-.1.07-.09.09-.18.09-.36.09Zm6.01-.09h-.36c-.18,0-.27,0-.36-.09,0-.07-.04-.13-.09-.18h0c.26-.21.57-.34.91-.36h.02c.07.01.07.11.07.27,0,.18,0,.27-.09.27-.02,0-.05,0-.06.03s-.03.04-.03.06h0Zm-2.1,0c-.18,0-.27,0-.27-.09,0-.07-.04-.13-.09-.18.09-.14.21-.26.35-.34.14-.08.31-.12.47-.12.06.08.09.17.09.27-.05.05-.09.12-.11.19-.02.06-.05.12-.07.17-.09.09-.18.09-.36.09Zm-5.65,0h-.36c-.19,0-.29,0-.31-.03,0-.01,0-.03.03-.06l-.09-.27.09-.27h.73c.09,0,.09.09.09.27s0,.27-.09.27l-.09.09Zm3.64-1.09c-.29,0-.46-.1-.46-.27.1-.29.29-.46,1-.46.09,0,.09.09.09.27s0,.27-.09.27l-.09.09-.46.09Zm-1.55-.27h-.18c-.18-.09-.27-.18-.27-.27.02-.06.05-.12.1-.17.05-.05.11-.08.17-.1.07,0,.13.04.18.09.02-.02.04-.04.06-.04s.03.02.03.06c0,.05,0,.11,0,.16,0,.18,0,.27-.09.27Zm3.46-.18c-.29,0-.46-.1-.46-.27h.01c.22-.11.42-.23.62-.36.1,0,.19-.01.28-.05.06-.03.12-.04.18-.04.09,0,.09.09.09.27s0,.27-.09.27c-.02,0-.05,0-.06.03-.02.02-.03.04-.03.06l-.55.09Zm-3.55-.91s-.1,0-.15-.01c-.05-.02-.09-.04-.13-.08l-.18-.18c.02-.06.05-.12.1-.17.05-.05.11-.08.17-.1.03-.02.06-.02.1-.02.13,0,.27.12.45.39-.04.06-.1.1-.16.13-.06.03-.13.05-.2.05Zm2.1-.27c-.07,0-.14-.03-.19-.08-.05-.05-.08-.12-.08-.19,0-.18.18-.27.36-.36.11-.06.24-.1.36-.09h.09c.09,0,.09.09.09.27,0,.08-.13.15-.44.34l-.2.12Zm1.37-.46h-.36c-.18,0-.27,0-.36-.09v-.18c.07-.15.19-.28.34-.36.15-.08.32-.11.48-.09.09,0,.18.09.18.27,0,.05,0,.1-.01.15-.02.05-.04.09-.08.13l-.09.09-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m42.02,39.55h-.18c-.09,0-.17-.02-.25-.06-.04-.02-.08-.03-.12-.03v-.46l.09-.09h.55l.08.04c.1.03.2.09.28.16.08.07.14.16.19.26-.18.14-.41.21-.64.18Zm5.38-.55h-.64c-.1-.07-.19-.12-.27-.17-.1-.05-.19-.12-.27-.19v-.09c0-.18,0-.27.09-.27l.09.09c.05-.11.08-.15.12-.15.05.01.11.03.15.06.09,0,.18,0,.18.09.25.1.47.25.64.46q-.09.09-.09.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m46.85,39.37c-.3-.07-.57-.19-.82-.36-.08-.07-.14-.15-.19-.25-.05-.09-.07-.2-.08-.3,0-.51.29-.75.91-.75.12,0,.24,0,.36.02.83.09,1.28.38,1.28.82,0,.17-.07.33-.18.46-.14.11-.29.2-.46.27-.27.08-.54.11-.82.09Zm-.64-1.18c-.06.08-.1.17-.09.27v.09c.08.07.18.14.27.19.08.05.17.1.27.17h.64q0-.09.09-.18c-.2-.21-.45-.37-.73-.46-.06,0-.12,0-.17-.02-.03-.01-.07-.02-.1-.02-.02,0-.03,0-.05.01-.02,0-.03.02-.04.03l-.09-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m42.11,40.82c-.15-.01-.29-.06-.42-.14-.13-.08-.23-.19-.31-.32-.04-.04-.07-.09-.09-.14-.02-.05-.05-.1-.09-.14.26.09.54.12.82.09.12.02.25.04.37.04.22,0,.43-.04.63-.13,0,.07-.04.13-.09.18-.07.16-.18.3-.33.4-.15.1-.32.15-.49.15Zm4.83-.82c-.13,0-.26-.03-.37-.09s-.21-.16-.27-.27c-.15-.16-.28-.34-.36-.55.18.18.45.18.82.18.31.03.62,0,.91-.09v.36c-.06.14-.16.27-.29.35-.13.08-.29.12-.44.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m42.11,40.28c-.28.03-.56,0-.82-.09-.17-.06-.32-.17-.44-.32-.11-.14-.18-.32-.2-.5,0-.29.21-.56.64-.82.41-.04.71-.05.95-.05.34-.05.68.04.96.24.18.09.18.27.18.64l-.09.46c0,.09,0,.27-.27.27-.29.12-.6.18-.91.18Zm-.55-.82c.09.09.18.09.36.09h.27c.23,0,.45-.05.64-.18h0c-.16-.18-.34-.33-.54-.46h-.55l-.09.09c-.08,0-.13.02-.16.06-.02.04-.03.08-.02.12,0,.21,0,.31.04.31.01,0,.03-.01.05-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m52.06,31.99c3.03,0,5.49-1.4,5.49-3.12s-2.46-3.12-5.49-3.12-5.49,1.4-5.49,3.12,2.46,3.12,5.49,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m47.04,27.35c-.04.62.08,1.24.34,1.81.27.56.67,1.05,1.17,1.41,1.07.76,2.39,1.09,3.69.95,1.02-.07,2.01-.33,2.94-.76.65-.29,1.19-.77,1.55-1.38.36-.61.51-1.32.44-2.03-.28-2.37-1.33-5.87-5.02-5.68-3.88.09-4.83,3.5-5.11,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m60.13,40.32c2.97,0,5.37-1.37,5.37-3.06s-2.41-3.06-5.37-3.06-5.37,1.37-5.37,3.06,2.41,3.06,5.37,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m59.3,32.38v5.04s.74.5,1.16,0v-5.04h-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m59.88,7.91c-4.71-.17-5.29,20.33-5.04,22.81.17,1.74,2.56,2.48,3.97,2.73.71.17,1.44.17,2.15,0,1.41-.33,3.8-1.07,3.97-2.73.25-2.4-.33-22.9-5.04-22.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.84,89.24s10.95,4.58,15.53,3.51,9.88-.21,9.88-.21c0,0,5.51,1.67,10.38-1.46s14.74-1.84,14.74-1.84c0,0,21.12-.64,22.9-5.73,1.79-5.08-1.72-7.16-1.72-7.16,0,0-3.44-.97-3.36-4.71s-5.3-5.1-5.3-5.1l-17.39-7.14-45.67,29.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "68.93 81.51 50.7 91.68 36.29 83.49 54.25 73.26 68.93 81.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "89.82 69.58 72.06 79.48 57.18 71.55 75.15 61.33 89.82 69.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "46.52 22.21 44.77 22.89 18.61 7.91 20.53 6.95 46.52 22.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "44.77 22.89 44.77 53.1 18.61 37.89 18.61 7.91 44.77 22.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "44.77 53.1 26.1 63.95 -.18 48.84 18.61 37.89 44.77 53.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "26.12 66.23 26.08 89.17 -.18 74.14 -.18 51.31 26.12 66.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "72.83 39.28 72.83 59.47 26.08 89.17 26.12 66.23 72.83 39.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m-.22,48.95v6.44s2.86,3.17,3.79,4.06,4.72,1.53,4.72,1.53l8.16,6.94,10.81,6.08,2.51-3.72s1.22-1.44,2.65-1.58,4.29-3.36,4.29-3.36l18.4-10.09s3.15-1.36,3.44-2.29,14.24-9.59,14.24-9.59v-6.37l-46.88,27.23L-.22,48.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "88.02 51.01 88.02 68.38 87.43 68.05 86.46 67.52 75.06 61.24 75.08 43.58 88.02 51.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "75.08 43.58 75.06 61.24 75.06 58.36 62.48 51.02 75.08 43.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m86.52,53.56s-.96,2.25-2.74,2.63c-1.77.38-2.36,2.47-2.36,2.47,0,0-.54,1.18-2.52,1.07-1.99-.11-2.85,1.29-2.85,1.29,0,0-.22.75-.81,0l-10.41-7.25,3.6-1.78s1.93-2.19,2.95-2.08c1.02.11,3.06-2.04,3.7-2.15.65-.11,1.99,1.72,1.99,1.72,0,0,1.72,2.25,4.62,1.88,2.9-.38,4.83,2.2,4.83,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m86.52,53.56v14.01l-14.72,8.56-6.97-3.62v-18.73l10.41,7.25c.59.75.81,0,.81,0,0,0,.86-1.4,2.85-1.29,1.99.11,2.52-1.07,2.52-1.07,0,0,.59-2.09,2.36-2.47,1.77-.38,2.74-2.63,2.74-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m76.77,57.78s0,.01,0,.02c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v1.56c-.8.81-1.62.9-2.28.75-.83-.19-1.42-.75-1.42-.75v-2.48c0-.73.38-1.4,1-1.78l.8-.48,1.55-.94h0c.32-.22.72-.35,1.15-.32,1.07.06,1.88,1.06,1.72,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m76.76,57.79c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v-.65c.02-.33.21-.62.52-.76l2.01-.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "73.33 59.42 73.33 78.77 73.29 78.79 58.83 71.14 58.83 50.95 73.33 59.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m70.52,61.29s0,.01,0,.02c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v1.56c-.8.81-1.62.9-2.28.75-.83-.19-1.42-.75-1.42-.75v-2.48c0-.73.38-1.4,1-1.78l.8-.48,1.55-.94h0c.32-.22.72-.35,1.15-.32,1.07.06,1.88,1.06,1.72,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m70.51,61.31c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v-.65c.02-.33.21-.62.52-.76l2.01-.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "89.61 50.09 89.61 69.63 73.33 78.77 73.33 59.42 75.06 58.36 75.06 75.79 88.02 68.38 88.02 51.01 88.04 51.02 89.61 50.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "88.02 68.38 75.06 75.79 75.06 74.18 86.46 67.52 87.43 68.05 88.02 68.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "75.06 61.24 86.46 67.52 75.06 74.18 75.06 61.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "89.61 50.09 88.04 51.02 88.02 51.01 75.08 43.58 62.48 51.02 75.06 58.36 73.33 59.42 58.83 50.95 75.08 41.5 89.61 50.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "72.83 36.98 72.83 39.28 46.52 54.53 44.46 53.29 72.83 36.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "46.52 22.21 46.52 54.53 26.12 66.23 -.18 51.31 -.18 48.84 26.1 63.95 44.77 53.1 44.77 22.89 46.52 22.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "68.93 61.97 68.93 81.51 52.53 90.71 52.53 88.89 54.33 87.85 54.33 87.85 67.08 80.51 67.08 62.9 68.93 61.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "67.08 62.9 67.08 80.51 65.65 79.83 54.25 73.26 54.25 55.55 67.08 62.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m54.25,55.55v17.72l-5.5,3.08c-.23-.44-.51-.94-.84-1.41-.81-1.18-1.77-4.13-1.77-4.13v-5.1l-4.56-2.79,12.67-7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m65.65,79.83l-12.48,7.14c-.28-.28-.53-.57-.63-.76-.27-.54-.75-2.25-1.13-2.63-.38-.38-1.45-2.42-1.61-3.28-.16-.86-.48-2.79-.48-2.79,0,0-.21-.51-.56-1.16l5.5-3.08,11.39,6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m60.84,77.67c-.05.34-.09.23-.9.57-.81.34-.15.55-.15,1.04s-.68.79-.95,1.34c-.27.55-1.02.95-1.65.78-.63-.17-.93-.28-1.49-.06-.55.21-1.47-.18-1.47-.18,0,0-.66-.75-1.31-.95-.65-.2-2-1.36-2.51-1.99s-1.82-.67-1.82-.67c.06-.48.2-1.15.49-1.12.46.04,1.75-.36,2.61-.61.86-.25,1.18-1.5,1.36-2.08.18-.57,1.29-.57,1.65-.2.36.37,1.36.17,1.72.03.36-.14.79.36,1.52,1,.73.64.77.25,1.49.43.72.18.97,1.61,1.39,1.61,0,0,.05.72,0,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m52.65,80.09v6.08l-2.28-2.18-1.81-5.94s.01-.21.04-.49c0,0,1.32.04,1.82.67.44.55,1.53,1.5,2.23,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m61.34,77.08c-.1.07-.04.39,0,.64.04.25-.5.57-.8.68-.3.11-.74.47-.24.5.5.04.07.47,0,.89-.07.43-.57.57-.97.86-.39.29.02.47.3.5.29.04.43.34.14.47-.29.13-.41.55-.27.47.14-.09.7.36.27.52-.43.16-.3.56-.3.56l-6.16,3.65-.67-.64v-6.08c.1.05.2.1.28.12.64.2,1.31.95,1.31.95,0,0,.91.39,1.47.18.56-.22.86-.1,1.49.06.63.17,1.38-.23,1.65-.78.27-.56.95-.86.95-1.34s-.66-.7.15-1.04c.81-.34.85-.23.9-.57.05-.34,0-1.05,0-1.05.43,0,.61.39.5.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "53.17 73.82 53.17 86.97 44.56 82.01 44.56 69.99 53.17 73.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m48.29,63.62s1.61.05,1.88.91.7,1.34.91,1.34.59.59,0,.75-.38.7-.38.7c0,0-.21.81-1.34.24l-.96-.48c-.14-.07-.24-.21-.25-.37,0-.15.06-.31.35-.36.34-.06.26-.24.15-.38s-.18-.31-.19-.49l-.06-1.28-.11-.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 52.53,
    y1: 90.75,
    x2: 52.53,
    y2: 90.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m60.22,63.84l-.8.48c-.62.38-1,1.05-1,1.78v3.98c-.28.14-.47.24-.47.24,0,0-2.04.86-2.36,1.66-.32.8-.7.75-.7.75,0,0-.59-.14-1,.55-.35.6-.73.54-.73.54l-8.6-3.83v-5.18c1.99.38,4.27-2.47,4.91-3.14.64-.67,3.59-1.93,4.78-2.07,1.18-.14,1.82.8,1.82.8,0,0,.3.89,1.08.91.78.03,2.55,1.26,2.78,2.07.04.12.14.28.28.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 51.22,
    cy: 66.9,
    rx: 2.38,
    ry: 1.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 51.22,
    cy: 66.9,
    rx: 4.63,
    ry: 2.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m48.54,64.58s0,.01,0,.02c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v1.56c-.8.81-1.62.9-2.28.75-.83-.19-1.42-.75-1.42-.75v-2.48c0-.73.38-1.4,1-1.78l.8-.48,1.55-.94h0c.32-.22.72-.35,1.15-.32,1.07.06,1.88,1.06,1.72,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m48.54,64.6c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v-.65c.02-.33.21-.62.52-.76l2.01-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m52.53,88.89v1.82l-.07.04-14.32-8.37v-19.2l6.31,3.43v4.99s1.42,4.4,2.44,5.21c1.02.81,1.13,2.95,1.13,2.95,0,0,.43,3.81,1.13,4.35.7.54,1.88,2.42,2.2,3.28.32.86,1.07,1.34,1.18,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m54.33,87.85l-1.8,1.04c-.11-.16-.86-.65-1.18-1.5-.32-.86-1.5-2.74-2.2-3.28-.7-.54-1.13-4.35-1.13-4.35,0,0-.11-2.15-1.13-2.95-1.02-.81-2.44-5.21-2.44-5.21v-4.99l1.69-.91v5.1s.97,2.95,1.77,4.13c.32.47.61.97.84,1.41.35.66.56,1.16.56,1.16,0,0,.32,1.93.48,2.79.16.86,1.23,2.9,1.61,3.28.38.38.86,2.09,1.13,2.63.1.2.35.48.63.76.48.48,1.06.94,1.16.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m67.08,80.51l-12.75,7.34h0c-.1.05-.68-.41-1.16-.89l12.48-7.14,1.44.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "68.93 61.97 67.08 62.9 54.25 55.55 41.58 62.9 46.15 65.7 44.46 66.61 38.15 63.17 38.15 62.88 54.32 53.6 68.93 61.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m65.65,66.96s-2.14.61-3.53,1.13v2.94c0,1.02-.83,1.85-1.85,1.85s-1.85-.83-1.85-1.85v-4.93c0-.73.38-1.4,1-1.78l.8-.48c.64.77,2.18,1.93,3.21,2.35.29.12.54.18.72.15.97-.14,1.49.62,1.49.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.65,64.7s0,.01,0,.02c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v1.56c-.8.81-1.62.9-2.28.75-.83-.19-1.42-.75-1.42-.75v-2.48c0-.73.38-1.4,1-1.78l.8-.48,1.55-.94h0c.32-.22.72-.35,1.15-.32,1.07.06,1.88,1.06,1.72,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m62.12,68.58v2.45c0,1.02-.83,1.85-1.85,1.85s-1.85-.83-1.85-1.85v-2.45s.58.56,1.42.75c.66.15,1.48.06,2.28-.75Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 62.12,
    y1: 71.12,
    x2: 62.12,
    y2: 71.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m65.65,66.96v12.87l-12.48,7.14v-13.15s.37.06.73-.54c.41-.69,1-.55,1-.55,0,0,.38.05.7-.75.32-.81,2.36-1.66,2.36-1.66,0,0,.19-.09.47-.24v.95c0,1.02.83,1.85,1.85,1.85s1.85-.83,1.85-1.85v-2.94c1.38-.52,3.53-1.13,3.53-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m64.65,64.71c-.1.63-.52,1.16-1.08,1.41l-.13.06-1.1.5c-.13.06-.21.19-.21.33v-.65c.02-.33.21-.62.52-.76l2.01-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.01,68.53c0,.8-.46,1.5-1.12,1.85l-9.37,5.66c-2.18,1.32-4.93,1.27-7.07-.12l-16.18-9.35c-1.11-.64-1.47-1.96-1.04-3.02.41.65,1.17,1.61,2.46,2.39,1.64,1,11.24,6.47,15.9,9.12,1.57.89,3.49.89,5.06-.01l11.36-6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m42.01,68.51v.02l-11.36,6.52c-1.57.9-3.49.9-5.06.01-4.66-2.65-14.26-8.12-15.9-9.12-1.29-.78-2.05-1.73-2.46-2.39.18-.46.51-.87.99-1.16l4.32-2.62h0c.31-.21.68-.33,1.08-.33,1.07,0,1.94.87,1.94,1.94,0,.12-.01.24-.04.36l-4.07,2.02.88.46,15.35,9.07,11.03-6.54.21-.13h0c.29-.15.62-.24.97-.24,1.17,0,2.12.95,2.12,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m15.52,61.74c-.1.53-.42.99-.86,1.27l-.33.17-2.01,1.04-.88-.46,4.07-2.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 61.96,
    cy: 78.87,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 62.81,
    cy: 72.11,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 63.18,
    cy: 68.32,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 62.73,
    cy: 74.36,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 62.02,
    cy: 75.8,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 62.4,
    cy: 77.03,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 61.49,
    cy: 78.08,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 60.47,
    cy: 80.4,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 55.59,
    cy: 83.07,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 57.54,
    cy: 80.56,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 55.18,
    cy: 78.51,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 58.67,
    cy: 78.08,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 56.01,
    cy: 74.18,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 52.57,
    cy: 71.05,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 55.77,
    cy: 69.85,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 55.53,
    cy: 76.7,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 54.65,
    cy: 74.12,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 55.84,
    cy: 79.3,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 52.74,
    cy: 79.25,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 51.22,
    cy: 77.18,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 53.73,
    cy: 78.61,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 56.9,
    cy: 79.25,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 57.24,
    cy: 76.95,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 56.26,
    cy: 75.18,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 50.55,
    cy: 76.95,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 53.17,
    cy: 77.03,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 54.79,
    cy: 75.98,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 60.86,
    cy: 81.6,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 61.81,
    cy: 80.04,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 61.91,
    cy: 77.71,
    r: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Toiryyr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m30.82,44.14v1.42s-.07.61-.49.76c0,0,.37.15.34.61l-.24,2.54s.1.46-.56.86l-7.58,4.45s-1.93,1.32-4.11.27c0,0-.44,0-1.2-1.2l-.81-1.56s-.54-1.66-.29-2.22c0,0-2.06-1.69-2.07-3.16l17-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m24.98,52.74s.62-2.92,2.47-4c0,0,1.27-.34,1.71,1.42l-4.18,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m13.59,45.81v-.73c0-.1,0-.2,0-.3v-.02h0c.09-1.12,1.07-1.92,1.07-1.92l7.53-4.28.5-.32,2.43-.9,7.46,3.87c.11.05.16.13.17.23h0s0,1.2,0,1.2l-.02.02c-.08.28-.35.58-.35.58l-9,5.16c-1.98,1.03-2.62.88-2.62.88-4.64.37-5.72-1-5.72-1-1.03-.76-1.41-1.5-1.46-2.16h0s0,0,0,0c0-.1,0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m22.19,38.57l-7.53,4.28s-2.66,2.15.39,4.4c0,0,1.08,1.37,5.72,1,0,0,.64.15,2.62-.88l9-5.16s.68-.77.2-.99l-7.46-3.87-2.43.9-.5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m22.84,38.27v-5.02s0-.46.36-.6,1.56-.8,1.56-.8c0,0,.68-.37,1.52,0s5.1,2.72,5.1,2.72c0,0,.62.29.67,1.35l.29,5.44s.02.26-.18.41-2.05,1.19-2.05,1.19c0,0-.37.15-.73,0l-6.26-3.57s-.28-.16-.28-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m30.44,36.85s-.57.47-1.34.08l-6.26-3.55s-.04-.55.36-.73l1.56-.8s.8-.35,1.52,0l5.1,2.72s.68.35.67,1.35l-1.61.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m29.87,37.09v5.93s.21-.04.46-.18l1.84-1.07s.14-.11.18-.41l-.29-5.44-1.61.93s-.34.18-.57.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m19,41.52s-4.25,1.77-3.74,3.63c0,0,.72,2.4,5.3,2.22,0,0,.72.03,1.83-.39l3.14-1.87s.12-.66,0-1.56c0,0-1.01-1.86-5.77-2.31l-.76.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m25.05,45.38s-.79-1.57-3.27-.64-.95,2.13-.95,2.13c0,0,.2.31,1.21.24l.37-.16,2.64-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m24.37,45.8s-.23-1.47-2.41-.68c0,0-1.48.77-.34,1.48,0,0,.29.24.94.27l1.81-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m19.76,41.22v1.22s3.88-.47,5.77,2.66c0,0,.19-.89,0-1.56,0,0-1.42-2.18-5.77-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m19.76,41.22v1.22s-3.36.85-4.5,2.71c0,0-.9-2.28,4.5-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m21.26,51.04s-3.31.9-5.44-1.03c0,0-.21,3.04,1.66,4.69,0,0,2.61,2.4,7.08-1.27,0,0-4.23,1.86-3.89.27s.59-2.66.59-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m30.23,45.43s-7.8,7.08-9.26,8.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m28.45,50.01l-3.2,1.83s.77-2.32,2.2-3.1c0,0,.71-.02,1,1.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-35",
    cx: 27.6,
    cy: 33.84,
    rx: 0.49,
    ry: 0.26
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepticTank);
export default __webpack_public_path__ + "static/media/septic-tank.43adb4c2aea3e40f80cac673a13bc163.svg";
export { ForwardRef as ReactComponent };